
/**
 * Custom arrow component for react-slick slider.
 *
 * @param {object} props - The component props.
 * @param {string} props.className - Classes applied to the arrow.
 * @param {object} props.style - Inline styles for the arrow.
 * @param {function} props.onClick - Click handler for the arrow.
 */
const SampleArrow = (props) => {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{ ...style, color: 'black', background: 'grey', borderRadius: 20 }}
            onClick={onClick}
        />
    )
}

export default SampleArrow
